export default __webpack_public_path__ + "media/waiting-room-connect-community.011dde9b.webp";